module.exports = __webpack_public_path__ + "static/about-us-map-cdac67ebd6b0271b4b8529ffef303533.svg";